<div class="fix-width mt-2">
  <nav *ngIf="pagination?.pages">
    <div class="d-flex gap-5 align-items-center m-0">
      <div class="d-flex gap-5  align-items-center">
        <div class="col d-flex  align-items-center">
          <ul class="pagination pagination-sm m-0">
            <li class="page-item" *ngIf="pagination.page > 1">
              <button class="page-link" (click)="firstPage()">
                <i class="bi bi-chevron-bar-left"></i>
              </button>
            </li>
            <li class="page-item">
              <button class="page-link" (click)="listPrevious()">
                <i class="bi bi-chevron-double-left"></i>
              </button>
            </li>
            <li *ngFor="let page of pagination.pages" class="page-item {{pagination.page==page?'active':''}}">
              <button class="page-link" (click)="listPage(page)">{{page}}</button>
            </li>
            <li class="page-item">
              <button class="page-link" (click)="listNext()">
                <i class="bi bi-chevron-double-right"></i>
              </button>
            </li>
            <li class="page-item" *ngIf="pagination.page < pagination.totalPage">
              <button class="page-link" (click)="finalPage()">
                <i class="bi bi-chevron-bar-right"></i>
              </button>
            </li>

          </ul>
        </div>
        <div class="d-flex  align-items-center">
          <div class="input-group input-group-sm">
            <span class="input-group-text" id="gopage">{{'page_enter'|translate}}</span>
            <input type="number" class="form-control outline-0" aria-describedby="gopage" [value]="pagination.page"
              #gopage (keyup.enter)="goPage($event.target)" style="width: 80px;">
            <span class="input-group-text bg-white" id="gopage" role="button" (click)="goPage(gopage)">
              <i class="bi bi-chevron-bar-right text-primary"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="col-5">
        <span class="ms-5">{{'items_in_list'|translate}}: {{pagingOptions.limit}}</span>
        <span class="ms-5">{{'total_record'|translate}}: {{pagination.count}}</span>
      </div>
    </div>

  </nav>
</div>
